import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck2, CalendarClock, CheckCircle2, ClipboardList, PackageCheck, Wrench } from "lucide-react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { canOpenRoute } from "../lib/permissions";

// What needs doing today, built from the dashboard counts: each line opens the
// page where it gets done. Lines with nothing to do, or for pages this user
// cannot open, are left out.
export function todayTasks(stats, user, lead = {}) {
  return [
    { key: "delivery", icon: PackageCheck, tone: "tone-indigo", count: stats.in_delivery, label: "Consegne da confermare", to: "/consegne" },
    { key: "reserved", icon: CalendarCheck2, tone: "tone-sky", count: stats.reserved, label: "Mezzi prenotati da preparare", to: "/consegne" },
    { key: "deadlines", icon: CalendarClock, tone: "tone-red", count: stats.expiring_7, label: `Scadenze entro ${lead.days7 ?? 7} giorni`, to: "/scadenze" },
    { key: "maintenance", icon: Wrench, tone: "tone-amber", count: stats.maintenances_due, label: "Manutenzioni da fare", to: "/manutenzioni" },
    { key: "clients", icon: ClipboardList, tone: "tone-orange", count: stats.clients_to_complete, label: "Clienti da completare", to: "/clienti?completezza=da_completare", route: "/clienti" },
  ].filter((task) => Number(task.count) > 0 && canOpenRoute(user, task.route || task.to));
}

export default function TodayTasks({ stats, user, lead, actions }) {
  const tasks = todayTasks(stats, user, lead);
  return (
    <Card className="p-5" data-testid="today-tasks">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-heading text-lg font-semibold">Da fare oggi</h2>
        {actions}
      </div>
      {tasks.length === 0 ? (
        <p className="flex items-center gap-2 py-3 text-sm text-muted-foreground"><CheckCircle2 className="h-5 w-5 text-emerald-400" aria-hidden="true" />Tutto in ordine: niente in sospeso per oggi.</p>
      ) : (
        <ul className="divide-y divide-border">
          {tasks.map(({ key, icon: Icon, tone, count, label, to }) => (
            <li key={key}>
              <Link to={to} className="group flex min-h-14 items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-secondary/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">
                <span className={`icon-tile h-9 w-9 ${tone}`} aria-hidden="true"><Icon className="h-5 w-5" /></span>
                <span className="min-w-0 flex-1 text-sm font-medium">{label}</span>
                <span className="font-heading text-xl font-bold tabular-nums">{count}</span>
                <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}

export function TodayActions({ user, handover }) {
  return (
    <div className="flex flex-wrap gap-2">
      {handover && <Button asChild size="sm"><Link to="/consegne">Consegne e rientri</Link></Button>}
      {canOpenRoute(user, "/calendario") && <Button asChild size="sm" variant="outline"><Link to="/calendario">Calendario</Link></Button>}
    </div>
  );
}
